<template>
  <img :src="resolvedSrc" />
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  src: {
    type: String,
    default: ''
  }
})

const resolvedSrc = computed(() => props.src?.replace('cdn.sanity.io', 'images.shopviu.com'))
</script>
